export default "__VITE_ASSET__26379fd8__"